module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page1': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "headers",
    class: {
      'newV-header': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "headers-con",
    class: {
      'newV-header-con': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [(_vm.vipState === 0 || _vm.vipState === 'loginNo') ? _c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "header-tip"
  }, [_vm._v("大数据显示")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "header-des"
  }, [_vm._v("增强简历曝光、快速获得企业反馈、没有效果可获得6倍赔偿等N项特权")]), _vm._v(" "), _c('div', {
    staticClass: "header-card"
  }, [_c('span', {
    staticClass: "header-card-tip"
  }, [_vm._v("尚未开通")]), _vm._v(" "), _c('div', {
    staticClass: "header-buyBtn",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-kthy-fhy')
      }
    }
  }, [_c('p', {
    staticClass: "buyBtn-text"
  }, [_vm._v("开通会员尊享特权")])])]), _vm._v(" "), _c('p', {
    staticClass: "header-vipProtocol"
  }, [_vm._v("\n\t\t\t\t\t查看"), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员服务协议")]), _vm._v("》")])])]) : _vm._e(), _vm._v(" "), (_vm.vipState === 1 || _vm.vipState === 10) ? _c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl header-vipCard"
  }, [_c('img', {
    attrs: {
      "src": _vm.cardState === 20 ? require('../../../../assets/imgs/header-upgrade.png') : require('../../../../assets/imgs/header-all.png')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-cardtype"
  }, [_vm._v(_vm._s(_vm._f("cardType")(_vm.cardState)))]), _vm._v(" "), _c('span', {
    staticClass: "header-vipUser"
  }, [_vm._v(_vm._s(_vm.cvipMes.nickname))])]), _vm._v(" "), _c('li', {
    staticClass: "fr header-mes"
  }, [_c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("开启应聘快车道")]), _vm._v(" "), _c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("与众不同立即开始")]), _vm._v(" "), _c('div', {
    staticClass: "headers-btn-wrap",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-ljxf-hy')
      }
    }
  }, [_c('span', {
    staticClass: "headers-buyBtn"
  }, [_vm._v(_vm._s(_vm.renew ? '立即续费' : '立即开通'))])]), _vm._v(" "), _c('p', {
    staticClass: "headers-expri"
  }, [_c('span', [_vm._v("会员卡有效期：" + _vm._s(_vm.cvipMes.expireDate) + "前有效")]), _vm._v(" "), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员协议")]), _vm._v("》")])])])]) : _vm._e(), _vm._v(" "), (_vm.vipState === 2) ? _c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl header-vipCard"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/imgs/header-vipExpri.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-vipUser header-vipUserExpri"
  }, [_vm._v(_vm._s(_vm.cvipMes.nickname))])]), _vm._v(" "), _c('li', {
    staticClass: "fr header-mes"
  }, [_c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("开启应聘快车道")]), _vm._v(" "), _c('p', {
    staticClass: "headers-tit"
  }, [_vm._v("与众不同立即开始")]), _vm._v(" "), _c('div', {
    staticClass: "headers-btn-wrap",
    on: {
      "click": function($event) {
        return _vm.showDialog('pc-cvip-kapian-ljxf-gqhy')
      }
    }
  }, [_c('span', {
    staticClass: "headers-buyBtn"
  }, [_vm._v(_vm._s(_vm.renew ? '立即续费' : '立即开通'))])]), _vm._v(" "), _c('p', {
    staticClass: "headers-expri"
  }, [_c('span', [_vm._v("您的会员卡已失效" + _vm._s(_vm.cvipMes.outdates) + "天"), (_vm.renew) ? _c('span', [_vm._v("，现在续费立减10元")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "headers-agreement",
    on: {
      "click": _vm.showHyxy
    }
  }, [_vm._v("《"), _c('i', [_vm._v("会员协议")]), _vm._v("》")])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "header-title"
  }, [_vm._v("“ VIP金卡用户求职成功速度快"), _c('span', {
    staticClass: "header-day"
  }, [_vm._v("3倍")]), _vm._v(" ”")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f1f73a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/header/Header.vue
// module id = IFq7
// module chunks = 1